import React from 'react';

type AdminButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    variant?: 'primary' | 'danger' | 'warning' | 'ghost';
    size?: 'sm' | 'md';
    block?: boolean;
};

export const AdminButton = React.forwardRef<HTMLButtonElement, AdminButtonProps>(
    (
        { variant = 'primary', size = 'md', block, className = '', children, ...props },
        ref,
    ) => (
        <button
            ref={ref}
            type="button"
            className={`admin-btn admin-btn--${variant} admin-btn--${size}${block ? ' admin-btn--block' : ''} ${className}`.trim()}
            {...props}
        >
            {children}
        </button>
    ),
);

AdminButton.displayName = 'AdminButton';
